import { Box, Grid, Paper, Typography } from '@mui/material';

import dayjs from 'dayjs';
import { CalendarBooking } from '../SitterCalendar';

// Month Stats Component
interface MonthStatsProps {
  bookings: CalendarBooking[];
}

const MonthStats: React.FC<MonthStatsProps> = ({ bookings }) => {
  const currentMonth = dayjs().month();
  const currentYear = dayjs().year();

  const monthBookings = bookings.filter((booking) => {
    const bookingMonth = booking.startDate.month();
    const bookingYear = booking.startDate.year();
    return (
      bookingMonth === currentMonth && bookingYear === currentYear && booking.status !== 'cancelled'
    );
  });

  const totalEarnings = monthBookings.reduce((sum, booking) => sum + booking.price, 0);

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        This Month
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main' }}>
              {monthBookings.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Bookings
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main' }}>
              ${totalEarnings}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Earnings
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default MonthStats;
